import { Tables } from "@/lib/supabase/supabase_types_override";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useOrganizationCrmConnectionsItems({orgId, enabled}:{orgId?: Tables<'organisation'>['id'], enabled?: boolean}) {
    return useQuery({
        ...queryKeys.organisation.details(orgId!)._ctx.crmConnectionsItems(),
        enabled: !!orgId && enabled,
    })
}